import { isObject } from 'underscore';

import { PublishProjectPreview } from '@/connection/projects/publish-project-preview';
import SetupProjectPreview from '@/connection/projects/setup-project-preview';
import { RootState } from '@/store/main';
import { serializeError } from '@/store/utils/serialize-error';
import { BrandliveEvent } from '@/types/projects.types';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectState, ProjectStateReducerCreator } from '../types';
import { EToastTypes } from '@ui/toast/toast.types';

const setupProjectPreviewReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ eventUuid, channel }: { eventUuid: string; channel: number }, { rejectWithValue, getState }) => {
      try {
        const state = getState() as RootState;
        const workingProject = (state.project as ProjectState)?.workingProject as BrandliveEvent | null;
        if (workingProject?.event_preview) {
          return workingProject.event_preview;
        }
        const result = await SetupProjectPreview(eventUuid, channel);
        if (!result) {
          return rejectWithValue('Error loading project');
        }
        if ('error' in result) {
          console.error('loadProject error', result.error);
          return rejectWithValue(serializeError(result.error));
        }

        await PublishProjectPreview(result.uuid, eventUuid, result.url, channel);

        return result;
      } catch (e) {
        console.error(e);
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          if (state.workingProject) {
            state.workingProject.event_preview = action.payload;
          }
        }
        state.settingUpProjectPreview = false;
      },
      pending: (state) => {
        state.settingUpProjectPreview = true;
      },
      rejected: (state, action) => {
        state.settingUpProjectPreview = false;
        const payload = isObject(action?.payload) ? action?.payload : null;
        const fallbackMsg =
          payload?.message ||
          payload?.error ||
          `${state.workingProject?.name || 'Project'} preview could not be set up. Please refresh.`;
        const message = typeof payload === 'string' ? payload : fallbackMsg;
        toastTrigger(message, {
          type: EToastTypes.error,
        });
      },
    }
  );
};

export default setupProjectPreviewReducer;
